module.exports = __webpack_public_path__ + "img/iys-logo.ffd693ab.svg";